/**
 * Custom Mirror Builder - Gallery Interaction
 */
document.addEventListener('DOMContentLoaded', () => {
  const mainImage = document.querySelector('.mirror-builder__main-img');
  const thumbnails = document.querySelectorAll('.mirror-builder__thumb');
  const thumbnailsContainer = document.querySelector('.mirror-builder__thumbnails');

  if (!mainImage || !thumbnails.length) return;

  // Ensure first thumbnail is active on load (if no active thumbnail exists)
  const hasActive = Array.from(thumbnails).some(t => t.classList.contains('mirror-builder__thumb--active'));
  if (!hasActive && thumbnails[0]) {
    thumbnails[0].classList.add('mirror-builder__thumb--active');
  }

  // Handle thumbnail click
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const thumbnailImg = thumbnail.querySelector('.mirror-builder__thumb-img');
      
      if (!thumbnailImg) return;

      // Update main image
      const newSrc = thumbnailImg.src.replace(/width=\d+/, 'width=800');
      const newSrcset = `${thumbnailImg.src.replace(/width=\d+/, 'width=400')} 400w, ${thumbnailImg.src.replace(/width=\d+/, 'width=800')} 800w, ${thumbnailImg.src.replace(/width=\d+/, 'width=1200')} 1200w`;
      
      mainImage.src = newSrc;
      mainImage.srcset = newSrcset;
      mainImage.alt = thumbnailImg.alt;

      // Update active state
      thumbnails.forEach((t) => t.classList.remove('mirror-builder__thumb--active'));
      thumbnail.classList.add('mirror-builder__thumb--active');

      // Scroll thumbnail into view (mobile only)
      if (window.innerWidth < 1000 && thumbnailsContainer) {
        const thumbnailLeft = thumbnail.offsetLeft;
        const thumbnailWidth = thumbnail.offsetWidth;
        const containerWidth = thumbnailsContainer.offsetWidth;
        const scrollPosition = thumbnailLeft - (containerWidth / 2) + (thumbnailWidth / 2);
        
        thumbnailsContainer.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // Add keyboard navigation
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.setAttribute('tabindex', '0');
    thumbnail.setAttribute('role', 'button');
    thumbnail.setAttribute('aria-label', `View image ${index + 1}`);

    thumbnail.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        thumbnail.click();
      }
    });
  });

  // Add swipe support for mobile
  let touchStartX = 0;
  let touchEndX = 0;

  if (thumbnailsContainer && window.innerWidth < 1000) {
    thumbnailsContainer.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    thumbnailsContainer.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
  }

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) < swipeThreshold) return;

    // Find current active thumbnail
    const activeIndex = Array.from(thumbnails).findIndex((t) =>
      t.classList.contains('mirror-builder__thumb--active')
    );

    let nextIndex;
    if (diff > 0 && activeIndex < thumbnails.length - 1) {
      // Swipe left - next image
      nextIndex = activeIndex + 1;
    } else if (diff < 0 && activeIndex > 0) {
      // Swipe right - previous image
      nextIndex = activeIndex - 1;
    }

    if (nextIndex !== undefined && thumbnails[nextIndex]) {
      thumbnails[nextIndex].click();
    }
  }
});

/**
 * Mobile Sticky CTA Behavior
 * Shows sticky CTA as soon as user starts scrolling (scrollY > 0)
 * Hides when the inline CTA (.mirror-builder__cta) is visible in the viewport
 */
document.addEventListener('DOMContentLoaded', () => {
  const inlineCta = document.querySelector('.mirror-builder__cta');
  const stickyWrapper = document.querySelector('[data-sticky-cta]');

  if (!stickyWrapper) return;

  // Only apply on mobile/tablet (below 1000px)
  if (window.innerWidth >= 1000) return;

  let inlineCtaVisible = false;
  let ticking = false;

  // Track inline CTA visibility via IntersectionObserver
  if (inlineCta) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        inlineCtaVisible = entry.isIntersecting;
        updateStickyVisibility();
      });
    }, { threshold: 0, rootMargin: '0px' });

    observer.observe(inlineCta);
  }

  function updateStickyVisibility() {
    // Show only if user has scrolled AND inline CTA is not visible
    if (window.scrollY > 0 && !inlineCtaVisible) {
      stickyWrapper.classList.add('is-visible');
    } else {
      stickyWrapper.classList.remove('is-visible');
    }
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateStickyVisibility);
      ticking = true;
    }
  }, { passive: true });

  // Check on load
  updateStickyVisibility();

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1000) {
      stickyWrapper.classList.remove('is-visible');
    } else {
      updateStickyVisibility();
    }
  });
});

